
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surf-charts",
      function () {
        return require("private-next-pages/surf-charts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surf-charts"])
      });
    }
  